import React from 'react';
import s from './style.module.css';
import { connect } from 'react-redux';
import moment from 'moment';
import Firework from '../../components/firework';
import { queryParams } from '../../utils';

class Page3 extends React.Component {
  	componentWillMount() {
  		window.scrollTo(0,0);

  	}

	componentDidMount() {
		const q = queryParams();
		if (q.iframe) {
			window.parent.postMessage({
				type: 'pageUpdate',
				payload: 'CONFIRM_BOOKING'
			}, '*');
		}

		var data = {
			'email': this.props.email,
			'first_name': this.props.firstname,
			'last_name': this.props.lastname,
			'resource_id': process.env.REACT_APP_RESSOURCE_ID,
			'start_date': moment.utc(this.props.timeslot.start).toISOString(),
			'end_date': moment.utc(this.props.timeslot.end).toISOString(),
			'reservation_type_id': process.env.REACT_APP_RESERVATION_TYPE_ID,
			'phone_number': this.props.phone,
			'company': this.props.company,
			'custom_fields': {
				'Country__c': this.props.country,
				'Industry__c': this.props.industry,
				'Lead_Email__c' : this.props.email,
				'Companysize__c': this.props.companysize,
				'Description__c': this.props.description,
				'Newsletter__c': this.props.newsletter,
				"StartTime_Local__c": moment(this.props.timeslot.start).format("hh:mm A"),
				"StartDate_Local_Day__c" : moment(this.props.timeslot.start).format("DD"),
				"StartDate_Local_Year_month__c" : moment(this.props.timeslot.start).format("MMM YYYY")
			}
		}

		fetch(`${process.env.REACT_APP_API_BASE}/api/v1/pages/${process.env.REACT_APP_PAGE_PK}/reservations/`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		})
		.then(() => console.log("Success"))
		.catch(error => console.error(error))
	}


	render(props) {
		let startTime = moment(this.props.timeslot.start).format("HH:mm");
		let endTime = moment(this.props.timeslot.end).format("HH:mm");
		let date = moment(this.props.date).format("DD-MM-YYYY")
		return (
			<div className={s.content}>
				<Firework />
				<h3 className={`header-4 strong ${s.headline}`}>Your demo appointment has been confirmed!</h3>
				<p>A confimation email has been sent to</p>
				<p className="mb-10">{this.props.email}</p>
				<p>We look forward meeting you during the demo on {date} from {startTime} - {endTime}h.</p>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const { 
		date,
		timeslot,
		firstname,
    	lastname,
    	email,
    	phone,
		country,
		company,
		industry,
		companysize,
		description,
		newsletter,
		client
	} = state.page2;
	return { date, timeslot, firstname, lastname, email, phone, country, company, industry, companysize, description, newsletter, client};
}

export default connect(mapStateToProps, {})(Page3);